import React from 'react'
import { useSelector } from 'react-redux'
import { selectAppOnline } from 'redux/selector'

interface Props {
  translations?: { not_available_online: string }[]
}

const ErrorPage: React.FC<Props> = ({ translations }) => {
  const isOnlineFlag = useSelector(selectAppOnline)

  const onlineMessage =
    'Sorry, this content at the moment not available because you are offline. Please try again later.'
  let notAvailable =
    (translations && translations[0]?.not_available_online) ||
    'Sorry, this content at the moment not available. Please try again later.'

  notAvailable = !isOnlineFlag ? onlineMessage : notAvailable

  return (
    <div className='content-error text-center p-5'>
      <h6 style={{ fontWeight: 'bolder' }}>{notAvailable}</h6>
    </div>
  )
}

export default ErrorPage
